import { render, staticRenderFns } from "./TheNumberOfPlayersSelector.vue?vue&type=template&id=8a6e6368&scoped=true&"
import script from "./TheNumberOfPlayersSelector.vue?vue&type=script&lang=ts&"
export * from "./TheNumberOfPlayersSelector.vue?vue&type=script&lang=ts&"
import style0 from "./TheNumberOfPlayersSelector.vue?vue&type=style&index=0&id=8a6e6368&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6e6368",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VBtn,VCol,VContainer,VRow})
